import { fetchWithAuth } from './fetchWithAuth';

export async function executeVote(candidateId, cif, userToken) {
    return fetchWithAuth(
        'https://t41bx8uqf6.execute-api.us-east-2.amazonaws.com/prod/votacion/votar',
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'authorizationToken': userToken
            },
            body: JSON.stringify({
                IDCandidato: candidateId,
                CIF: cif
            })
        }
    );
}